module.exports = __webpack_public_path__ + "static/media/exercise.3c0b8e4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/lsc/exercise.svg
// module id = 435
// module chunks = 0